export default "__VITE_ASSET__DFitycB6__"